import wechat from 'weixin-js-sdk'
import { getJSSDKConfig } from '@/api/wechat'
import eventBus from '@/event_bus'

const WECHAT_API = [
    'startRecord',
    'stopRecord',
    'uploadVoice',
    'translateVoice',
    'onVoiceRecordEnd',
    'stopVoice',
    'playVoice',
    'onVoicePlayEnd',
    'previewImage'
]

export default async function initWechatSDK () {
    const config = await getJSSDKConfig()

    initJSSDK({
        // debug: true,
        ...config,
        jsApiList: WECHAT_API
    })
}

function initJSSDK (param) {
    wechat.error(err => {
        // eslint-disable-next-line
        console.error(err)
        eventBus.isWechatJSSDKError = true
        eventBus.isWechatJSSDKReady = false
    })
    wechat.ready(() => {
        eventBus.isWechatJSSDKError = false
        eventBus.isWechatJSSDKReady = true
    })

    wechat.config(param)
}
